import { AudioInputSource } from "@/types/audio";
import { LGMicrophoneService } from "../services/LGMicrophoneService";

export class LunaAudioSource implements AudioInputSource {
  private service: LGMicrophoneService;
  private currentStream: MediaStream | null = null;

  constructor() {
    console.info("🎙️ LunaAudioSource: Initializing Luna audio source");
    this.service = new LGMicrophoneService();
  }

  async getStream(): Promise<MediaStream> {
    console.info("🎙️ LunaAudioSource: Getting audio stream");
    try {
      // Get the stream from the service
      this.currentStream = await this.service.getAudioStream();
      console.info("🎙️ LunaAudioSource: Successfully obtained MediaStream");

      // Start recording (required for Luna API)
      await this.service.startRecording(
        () =>
          console.info("🎙️ LunaAudioSource: Recording started successfully"),
        () => console.info("🎙️ LunaAudioSource: Recording stopped"),
        (err) => console.error("🎙️ LunaAudioSource: Recording error:", err),
      );

      return this.currentStream;
    } catch (error) {
      console.error("🎙️ LunaAudioSource: Failed to get stream:", error);
      throw error;
    }
  }

  stopStream(): void {
    console.info("🎙️ LunaAudioSource: Stopping stream");
    if (this.service) {
      this.service.stopRecording();
    }
    if (this.currentStream) {
      console.info("🎙️ LunaAudioSource: Stopping MediaStream tracks");
      this.currentStream.getTracks().forEach((track) => {
        track.stop();
        console.debug(
          "🎙️ LunaAudioSource: Stopped track:",
          track.kind,
          track.label,
        );
      });
      this.currentStream = null;
    }
  }
}
